<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
        border: 1px solid var(--el-border-color-lighter);
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          padding: 20px;

          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        "
      >
        <ul
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <li style="display: flex; align-items: center; font-size: 14px">
              <text style="font-weight: 600">{{ state.model.name }}</text>
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="工资表编号"
                @click="$onCopy(state.model.order_id)"
              >
                ({{ state.model.order_id }})
              </text>
              <strong
                v-if="state.model.tax_status_count_name == '未算税'"
                style="color: #a2a2a2"
                >{{ state.model.tax_status_count_name }}</strong
              >
              <strong
                v-else-if="state.model.tax_status_count_name == '部分算税'"
                style="color: #ffa500"
                >{{ state.model.tax_status_count_name }}</strong
              >
              <strong
                v-else-if="state.model.tax_status_count_name == '已算税'"
                style="color: #080"
                >{{ state.model.tax_status_count_name }}</strong
              >
            </li>
            <el-popover placement="bottom-end" width="60%" trigger="hover">
              <template #reference>
                <el-icon
                  size="20"
                  color="#1e90ff"
                  style="margin-left: 5px; cursor: pointer"
                >
                  <View />
                </el-icon>
              </template>
              <template #default>
                <div style="font-weight: 600; font-size: 13px">基本信息</div>
                <el-descriptions
                  :column="2"
                  border
                  style="overflow-x: auto; margin-top: 10px"
                  class="desc-label-nowrap"
                >
                  <el-descriptions-item label="名称" label-align="right">
                    <div style="width: 200px">
                      {{ state.model.name }}
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="操作状态/算税状态"
                    label-align="right"
                  >
                    <div style="width: 200px">
                      <text
                        :style="{
                          color: state.model.status == 0 ? '#1e90ff' : '#080',
                        }"
                      >
                        {{ state.model.status == 0 ? "操作中" : "已完成" }}
                      </text>
                      <text
                        v-if="state.model.tax_status_count_name == '未算税'"
                        style="color: #a2a2a2"
                        >{{ "/" + state.model.tax_status_count_name }}</text
                      >
                      <text
                        v-else-if="
                          state.model.tax_status_count_name == '部分算税'
                        "
                        style="color: #ffa500"
                        >{{ "/" + state.model.tax_status_count_name }}</text
                      >
                      <text
                        v-else-if="
                          state.model.tax_status_count_name == '已算税'
                        "
                        style="color: #080"
                        >{{ "/" + state.model.tax_status_count_name }}</text
                      >
                      <text v-else>{{ "/-" }}</text>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="所属客户" label-align="right">
                    {{ state.model.customer?.name || "-" }}
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="客户服务类型"
                    label-align="right"
                  >
                    {{ state.model.customer?.d_service_name || "-" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="报税类型" label-align="right">
                    {{ state.model.d_tax_type_name || "-" }}
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="个税承担方式"
                    label-align="right"
                  >
                    {{ state.model.tax_mode == 0 ? "个人" : "公司" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="薪资所属期" label-align="right">
                    {{ $dayjs(state.model.month).format("YYYY年M月") }}
                  </el-descriptions-item>
                  <el-descriptions-item label="税款所属期" label-align="right">
                    {{ $dayjs(state.model.tax_month).format("YYYY年M月") }}
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="约定发薪日期"
                    label-align="right"
                  >
                    {{ state.model?.pay_date }}
                  </el-descriptions-item>
                  <el-descriptions-item label="客服专员" label-align="right">
                    {{
                      state.model.belonger_name +
                      "/" +
                      state.model.belonger_department_name
                    }}
                  </el-descriptions-item>
                  <el-descriptions-item label="创建时间" label-align="right">
                    {{ state.model.create_time }}
                  </el-descriptions-item>
                </el-descriptions>
              </template>
            </el-popover>
          </div>
          <li style="display: flex; align-items: center">
            <text style="font-weight: 600">
              {{ state.model.customer?.name }}
            </text>
            <text
              style="color: #1e90ff; margin-top: 5px"
              class="text-hover-decoration"
              title="客户社会统一信用代码"
              @click="
                $onCopy(state.model.customer?.unified_social_credit_identifier)
              "
            >
              ({{ state.model.customer?.unified_social_credit_identifier }})
            </text>
          </li>
          <el-button
            type="primary"
            link
            icon="Edit"
            @click="state.showEdit = true"
            v-if="$judge_auth('104')"
          >
            编辑
          </el-button>
        </ul>
      </ul>
      <div
        style="
          padding: 20px;
          border-color: var(--el-border-color-lighter);
          border-width: 0 1px;
          border-style: solid;
          overflow-x: auto;
          display: flex;
          white-space: nowrap;
        "
      >
        <div
          style="
            border-radius: 7px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            column-gap: 10px;
            flex: 1;
          "
        >
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">结算金额：</text>
            <c_money
              :value="parseFloat(state.model.settle_amount)"
              style="color: #1e90ff; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">已收款：</text>
            <c_money
              :value="parseFloat(state.model.receipt_amount)"
              style="color: #080; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">欠款：</text>
            <c_money
              :value="parseFloat(state.model.arrearage_amount)"
              style="color: #f00; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
          <li style="display: flex; align-items: center">
            <text style="color: #a2a2a2">员工数量：</text>
            <text
              style="
                font-weight: 600;
                font-size: 20px;
                color: rgba(0, 0, 0, 0.6);
              "
            >
              {{ $priceFormat(state.model.employee_num || 0, 0) }}
            </text>
          </li>
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">发薪总额：</text>
            <c_money
              :value="parseFloat(state.model.pay_amount)"
              style="color: #1e90ff; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">已发放：</text>
            <c_money
              :value="parseFloat(state.model.paied_amount)"
              style="color: #080; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">未发放：</text>
            <c_money
              :value="parseFloat(state.model.unpaied_amount)"
              style="color: #f00; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
          <li style="display: flex; align-items: flex-end">
            <text style="color: #a2a2a2">应缴个税：</text>
            <c_money
              :value="
                parseFloat(
                  state.model?.tax_mode == 0
                    ? state.model.personal_income_tax
                    : state.model.company_income_tax
                )
              "
              style="color: #f00; font-weight: 600"
              :size="20"
            ></c_money>
          </li>
        </div>
      </div>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
          @tab-change="onTabsChange"
        >
          <el-tab-pane label="工资表明细" name="mx">
            <c_PayrollRecord
              v-if="state.model.id && state.activeName == 'mx'"
              :payroll_id="props.data?.id"
              :model="state.model"
              @onLoad="onLoad()"
            ></c_PayrollRecord>
          </el-tab-pane>
          <el-tab-pane label="个税核算" name="hs">
            <c_PayrollCalcTaxRecord
              v-if="state.model.id && state.activeName == 'hs'"
              :payroll_id="props.data?.id"
            ></c_PayrollCalcTaxRecord>
            <!-- <c_Account
              v-if="
                state.model.withholding_agent_type === 0 &&
                state.model.status === 1
              "
              :payroll_id="props.data?.id"
            ></c_Account>
            <div
              style="
                padding-top: 20px;
                text-align: center;
                color: #a2a2a2;
                color: #ffa500;
                font-size: 13px;
              "
              v-else
            >
              <text v-if="state.model.withholding_agent_type != 0">
                当前算税单为<strong style="color: #080">“外协算税单”</strong
                >，暂无个税核算数据~
              </text>
              <text v-if="state.model.status != 1">
                当前算税单状态不为<strong style="color: #080">“已算税”</strong
                >，暂无个税核算数据~
              </text>
            </div> -->
          </el-tab-pane>
        </el-tabs>
      </ul>
      <!-- 
      <div
        style="flex: 1; overflow: hidden; display: flex; flex-direction: column"
      >
        <c_PayrollRecord
          v-if="state.model.id"
          :payroll_id="props.data?.id"
          :model="state.model"
          @onLoad="onLoad()"
        ></c_PayrollRecord>
      </div> -->
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="修改工资表"
      @close="state.showEdit = false"
    >
      <c_PayrollInfo
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_PayrollInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { payroll_detail } from "@/http/payroll";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      activeName: "mx",
      model: {},
      rlzData: [],
      yrlData: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      payroll_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };

    return { state, props, onLoad };
  },
};
</script>
<style scoped lang="less">
.bankreceived-detail-rlzbox {
  box-shadow: 0 0 10px 1px #e2e2e2;
  padding: 20px 10px;
  border-radius: 7px;
  margin-top: 10px;
  display: flex;

  & > .bankreceived-detail-rlzbox-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    font-size: 13px;
    overflow: hidden;

    & > div {
      width: 25%;
      display: flex;
      align-items: flex-start;
      overflow: hidden;
      min-height: 30px;

      & > li:first-child {
        width: 100px;
        text-align: right;
        color: #a2a2a2;
      }
      & > li:last-child {
        flex: 1;
        word-break: break-all;
      }
    }
  }
}
</style>
